module.exports = __webpack_public_path__ + "static/media/home_icon.eaf25711.png";


//////////////////
// WEBPACK FOOTER
// ./src/home_icon.png
// module id = 306
// module chunks = 0